var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Defaults, ViewChild, PropertyConverters, preventDefaultHandler } from '@pacem/pacem-core';
import { Components } from '@pacem/pacem-ui';
import { PacemTextualInputElement } from './input';
import { CHAR_COUNTER_CHILD } from './char-counter';
//namespace Pacem.Components.Scaffolding {
let PacemMarkdownTextAreaElement = class PacemMarkdownTextAreaElement extends PacemTextualInputElement {
    constructor(_md = new Components.UI.MarkdownService()) {
        super();
        this._md = _md;
        this.rows = 5;
        this.cols = 50;
        this._keydownHandler = (evt) => {
            if (evt.keyCode === 9 /* tab */) {
                const input = this.input, value = input.value;
                var ndx = input.selectionStart;
                input.value = value.substr(0, ndx) + '    ' + value.substr(ndx);
                preventDefaultHandler(evt);
            }
        };
    }
    toggleReadonlyView(readonly) {
        this.input.hidden = readonly;
    }
    /** @override */
    get preventKeyboardSubmit() {
        return true;
    }
    get inputFields() {
        return [this.input];
    }
    getViewValue(val) {
        return this._md.toHtml(val);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'rows'
            || name === 'cols') {
            this.inputField.setAttribute(name, val);
        }
        else if (name == 'viewValue') {
            this._markdown.innerHTML = val;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.input.addEventListener("keydown", this._keydownHandler, false);
    }
    disconnectedCallback() {
        this.input &&
            this.input.removeEventListener("keydown", this._keydownHandler, false);
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMarkdownTextAreaElement.prototype, "rows", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMarkdownTextAreaElement.prototype, "cols", void 0);
__decorate([
    ViewChild('textarea')
], PacemMarkdownTextAreaElement.prototype, "input", void 0);
__decorate([
    ViewChild(`div.${PCSS}-readonly`)
], PacemMarkdownTextAreaElement.prototype, "_markdown", void 0);
PacemMarkdownTextAreaElement = __decorate([
    CustomElement({ tagName: P + '-textarea-markdown', template: `<textarea class="${PCSS}-input" pacem></textarea>${CHAR_COUNTER_CHILD}<div class="${PCSS}-readonly ${PCSS}-markdown"></div>`, shadow: Defaults.USE_SHADOW_ROOT })
], PacemMarkdownTextAreaElement);
export { PacemMarkdownTextAreaElement };
